'use client';

import { BadgeCheck, CircleEllipsis, HelpCircle } from 'lucide-react';
import { Tooltip } from './Tooltip';

export interface KycIconT {
  missing: string;
  pending: string;
  confirmed: string;
}

export function KycIcon({ kycState, t }: { kycState: number; t: KycIconT }) {
  switch (kycState) {
    case 0:
      return (
        <Tooltip tip={t.missing}>
          <HelpCircle className="cursor-help" />
        </Tooltip>
      );
    case 1:
      return (
        <Tooltip tip={t.confirmed}>
          <BadgeCheck className="cursor-help" />
        </Tooltip>
      );
    case 2:
      return (
        <Tooltip tip={t.pending}>
          <CircleEllipsis className="cursor-help" />
        </Tooltip>
      );
    default:
      return null;
  }
}
